<template>
  <div class="overflow-x-auto scrollbar-hidden member-datatable" data-test="member-datatable">
      <Datatable :api-params="paramsComputed" :api-url="'user/listUser'" :method-request="'POST'" :data-array-table="dataArrayTable" :key="key" :default-sort="[{field:'uid',dir:'asc'}]" @rowSelected="rowSelectedHandle" id="cm-datatable" :deselect="cancelModal"/>
  </div>
</template>

<script>
import Datatable from "@/components/datatable/index.vue"
import { defineComponent,reactive,ref,onMounted, watch, computed } from "vue"
import Swal from "sweetalert2"

const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary m-1',
    cancelButton: 'btn btn-outline-secondary m-1'
  },
  buttonsStyling: false
})

export default defineComponent({
    props:{
        filter:{
            type: Object
        },
        cancelModal:{
            type: Boolean,
            default: false
        },
        reloadTable:{
            type: Boolean,
            default: false
        }
    },
    components:{
        Datatable
    },
    setup(props,{emit}){
        const dataArray = ref()
        const params = ref({start: '1',draw: '1',length: '10'})
        const key = ref(1)
        watch(()=>props.filter, ()=>{
            key.value++
        })
        watch(()=>props.reloadTable,(val)=>{
            if(val){
                key.value++
            }
        })
        const paramsComputed = computed(() => ({...params.value, ...props.filter}))
        var customNameMutator = (value, data, type, params, component) => {
            return `${data.title ? data.title : ""}${data.name ? data.name: ""} ${data.surname ? data.surname : ""}`
        }
        const dataArrayTable = reactive([
            {formatter:"rowSelection", titleFormatter:"rowSelection", hozAlign:"center", headerSort:false, minWidth: 80, width:80, cellClick:function(e, cell){
                cell.getRow().toggleSelect();
            }},
            {title:"ชื่อผู้ใช้งาน", field:"uid",minWidth: 150, resizable:true, formatter:"textarea"},
            {title:"ชื่อ-สกุล", field:"name",minWidth: 150, resizable:true, formatter:"textarea", mutator: customNameMutator},
            {title:"ตำแหน่ง", field:"position",minWidth: 150, resizable:true, formatter:"textarea"},
        ])
        const rowSelectedHandle = (evt) =>{
            emit("cmSelectedList", evt.map(x=>x.uid))
        }

        return {
            dataArrayTable,
            params,
            key,
            paramsComputed,
            dataArray,
            rowSelectedHandle
        }
    }
})
</script>

<style lang="scss">

</style>